<div class="header-fixed w-100">
    <!-- <div class="news-scroll">
        <div class="newsbtn">
            <mat-icon> list_alt</mat-icon>
            <span class="ms-1">News</span>
        </div>
        <ul class="mb-0 p-0">
            <li>We are India’s market leader in commercial vehicles and amongst the top three in the passenger vehicles
                market. </li>
        </ul>
    </div> -->

    <div class="header-new" id="scroll-uptoheader">
        <div class="logoContainer">
            <!-- <a class="me-3" type="button" data-bs-toggle="offcanvas" data-bs-target="#NavbarOffcanvas"
                aria-controls="NavbarOffcanvas">
                <mat-icon>sort</mat-icon>
               
            </a> -->
            <div class="svg-middle-align cursor-pointer">
                <!-- <img src="../../../../assets/images/logo.svg" class="LGI_Logo" alt="Liberty Partner First Home"
          title="Liberty Partner First Home" /> -->
                <img src="../../../../assets/images/liberty-logo.webp" class="LGI_Logo" alt="Liberty General Insurance"
                    title="Liberty General Insurance" width="164" height="56" />
            </div>
        </div>
    </div>
</div>
<div *ngIf="!isMultiplePayment" class="container-fluid px-lg-4">
    <div class="mt-5">
        <mat-accordion>
            <mat-expansion-panel [(expanded)]="panelOpenState">

                <div class="mainform h-100 overflow-hidden">

                    <h5 class="my-3"> Business Details </h5>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="labelName d-block">Product Type</label>
                            <label class="labelValue">{{ responseData?.productName}}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">Customer Type</label>
                            <label class="labelValue">{{ responseData?.customerType }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">RTO</label>
                            <label class="labelValue">{{ responseData?.rtoCode }}</label>
                        </div>
                    </div>

                    <h5 class="my-3"> Risk Details </h5>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="labelName d-block">Policy Start Date</label>
                            <label class="labelValue">{{ responseData?.policyStartDate | date:"dd-MM-yyyy" }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">Policy End Date</label>
                            <label class="labelValue">{{ responseData?.policyEndDate | date:"dd-MM-yyyy" }}</label>
                        </div>
                    </div>

                    <h5 class="my-3"> IMD Details </h5>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="labelName d-block">IMD Name</label>
                            <label class="labelValue">{{ responseData?.imdName }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">IMD Code</label>
                            <label class="labelValue">{{ responseData?.imdCode }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">IMD Contact</label>
                            <label class="labelValue">{{ responseData?.imdContact }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">IMD Servicing Branch</label>
                            <label class="labelValue">{{ responseData?.imdBranchName }}</label>
                        </div>
                    </div>

                    <h5 class="my-3"> Premium </h5>
                    <div class="row align-items-end">
                        <!-- <div class="col-md-12 mb-2">
                            <strong>Total Premium Payable: <span>{{ responseData?.totalPremiumPayable
                                    }}</span></strong>
                        </div> -->
                        <div class="col-md-12 my-2">
                            <div class="w-100">
                                <div class="addonCard">
                                    <mat-checkbox class="example-margin" color="primary" [checked]="isChecked(0)"
                                        disabled></mat-checkbox>
                                    <div class="addonHeader">

                                        <ul class="addonlist">
                                            <li *ngFor="let addon of responseData?.addOns">
                                                <!-- <span class="me-1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                        viewBox="0 0 16 16" fill="none">
                                                        <path d="M2.6665 8.66663L5.99984 12L13.3332 4.66663"
                                                            stroke="#06748C" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                </span> -->

                                                <span>{{ addon?.coverName }}</span>
                                                <a class="tooltipicon" matTooltipPosition="right"
                                                    aria-label="Button that shows a red tooltip"
                                                    matTooltipClass="tooltipbox" [matTooltip]="addon?.coverDescription">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15"
                                                        viewBox="0 0 14 15" fill="none">
                                                        <g opacity="0.5">
                                                            <path
                                                                d="M6.4165 4.58341H7.58317V5.75008H6.4165V4.58341ZM6.99984 10.4167C7.32067 10.4167 7.58317 10.1542 7.58317 9.83341V7.50008C7.58317 7.17925 7.32067 6.91675 6.99984 6.91675C6.679 6.91675 6.4165 7.17925 6.4165 7.50008V9.83341C6.4165 10.1542 6.679 10.4167 6.99984 10.4167ZM6.99984 1.66675C3.77984 1.66675 1.1665 4.28008 1.1665 7.50008C1.1665 10.7201 3.77984 13.3334 6.99984 13.3334C10.2198 13.3334 12.8332 10.7201 12.8332 7.50008C12.8332 4.28008 10.2198 1.66675 6.99984 1.66675ZM6.99984 12.1667C4.42734 12.1667 2.33317 10.0726 2.33317 7.50008C2.33317 4.92758 4.42734 2.83341 6.99984 2.83341C9.57234 2.83341 11.6665 4.92758 11.6665 7.50008C11.6665 10.0726 9.57234 12.1667 6.99984 12.1667Z"
                                                                fill="#333740" />
                                                        </g>
                                                    </svg>
                                                </a>
                                            </li>
                                        </ul>
                                        <div class="d-flex flex-column addonPremium">
                                            <span class="price">Addon Premium</span>
                                            <span class="font-weight-bold">₹ {{
                                                responseData?.totalAddonCoverPremium }}</span>
                                        </div>
                                        <div class="d-flex flex-column addonPremium">
                                            <span class="price">Total Premium Payable</span>
                                            <span class="font-weight-bold">₹ {{ responseData?.totalPremiumPayable
                                                }}</span>
                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    <h5 class="my-3"> Customer Details </h5>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="labelName d-block">Customer Name</label>
                            <label class="labelValue">{{ responseData?.customerName }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">Customer Mobile Number</label>
                            <label class="labelValue">{{ responseData?.customerMobile }}</label>
                        </div>
                        <div class="col-md-3">
                            <label class="labelName d-block">Customer Email</label>
                            <label class="labelValue">{{ responseData?.customerEmail }}</label>
                        </div>
                    </div>

                    <h5 class="my-3"> Declaration by Insured </h5>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-slide-toggle [(ngModel)]="isDeclarationAccepted" aria-checked="true" class="h-auto">
                                <span class="text-wrap">
                                    I/We hereby declare that the statements made by me/us in this Proposal Form
                                    and
                                    annexures if any are true to the best of my/ our knowledge and belief and
                                    I/We
                                    hereby
                                    agree that this declaration shall form the basis of the contract between
                                    me/us
                                    and
                                    the
                                    “Liberty General Insurance Limited. If any additions or altercations are
                                    carried
                                    out
                                    in
                                    the risk proposed after the submission of this proposal form then the same
                                    should be
                                    conveyed to the insurers immediately.

                                    Prohibition of Rebates(Section 41) of Insurance Act No person shall or offer
                                    to
                                    allow
                                    either directly or indirectly as an inducement to any person to take out or
                                    renew of
                                    continue an insurance in respect of any kind of risk relating to lives or
                                    property
                                    in
                                    India, any rebate of whole or part of the commission payable or any rebate
                                    of
                                    the
                                    premium shown on the policy, nor shall any person taking out or renewing or
                                    continuing a
                                    policy accept any rebate except such rebate as maybe allowed in accordance
                                    with
                                    the
                                    published prospectuses or tables of the Insurer.

                                    Any person making default in complying with the provisions of this section
                                    shall
                                    be
                                    punishable with Fine, which may extend to Five Hundred Rupees. Insurance is
                                    the
                                    subject
                                    to matter of solicitation.
                                </span>
                                <a href="#" class="tooltipicon" data-bs-toggle="tooltip"
                                    data-bs-title="Default tooltip">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15"
                                        fill="none">
                                        <g opacity="0.5">
                                            <path
                                                d="M6.4165 4.58341H7.58317V5.75008H6.4165V4.58341ZM6.99984 10.4167C7.32067 10.4167 7.58317 10.1542 7.58317 9.83341V7.50008C7.58317 7.17925 7.32067 6.91675 6.99984 6.91675C6.679 6.91675 6.4165 7.17925 6.4165 7.50008V9.83341C6.4165 10.1542 6.679 10.4167 6.99984 10.4167ZM6.99984 1.66675C3.77984 1.66675 1.1665 4.28008 1.1665 7.50008C1.1665 10.7201 3.77984 13.3334 6.99984 13.3334C10.2198 13.3334 12.8332 10.7201 12.8332 7.50008C12.8332 4.28008 10.2198 1.66675 6.99984 1.66675ZM6.99984 12.1667C4.42734 12.1667 2.33317 10.0726 2.33317 7.50008C2.33317 4.92758 4.42734 2.83341 6.99984 2.83341C9.57234 2.83341 11.6665 4.92758 11.6665 7.50008C11.6665 10.0726 9.57234 12.1667 6.99984 12.1667Z"
                                                fill="#333740" />
                                        </g>
                                    </svg>
                                </a>
                            </mat-slide-toggle>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 my-3">
                            <div *ngIf="!isCustomerProposalMakePaymentSuccess" class="btngroup justify-content-center">
                                <button mat-raised-button color="primary" (click)="makePayment()">Make
                                    Payment</button>
                            </div>
                            <div *ngIf="isCustomerProposalMakePaymentSuccess" class="link">
                                <div class="d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19"
                                        fill="none">
                                        <path
                                            d="M9 5.21289C9.31065 5.21289 9.5625 5.46473 9.5625 5.77539V9.66737L10.8523 8.37767C11.0719 8.15799 11.428 8.15799 11.6477 8.37767C11.8674 8.59734 11.8674 8.95344 11.6477 9.17312L9.39772 11.4231C9.29227 11.5286 9.14917 11.5879 9 11.5879C8.85082 11.5879 8.70772 11.5286 8.60227 11.4231L6.35225 9.17312C6.13258 8.95344 6.13258 8.59734 6.35225 8.37767C6.57192 8.15799 6.92808 8.15799 7.14775 8.37767L8.4375 9.66737V5.77539C8.4375 5.46473 8.68935 5.21289 9 5.21289Z"
                                            fill="#1C274C" />
                                        <path
                                            d="M5.4375 13.2754C5.4375 12.9647 5.68934 12.7129 6 12.7129H12C12.3106 12.7129 12.5625 12.9647 12.5625 13.2754C12.5625 13.586 12.3106 13.8379 12 13.8379H6C5.68934 13.8379 5.4375 13.586 5.4375 13.2754Z"
                                            fill="#1C274C" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M8.95695 1.46289C7.22567 1.46288 5.86889 1.46288 4.81028 1.6052C3.72673 1.75088 2.87171 2.05489 2.20061 2.726C1.5295 3.3971 1.22549 4.25212 1.07981 5.33567C0.937485 6.39428 0.937493 7.75106 0.9375 9.48234V9.56844C0.937493 11.2997 0.937485 12.6565 1.07981 13.7151C1.22549 14.7986 1.5295 15.6537 2.20061 16.3248C2.87171 16.9959 3.72673 17.2999 4.81028 17.4456C5.86889 17.5879 7.22567 17.5879 8.95695 17.5879H9.04305C10.7744 17.5879 12.1311 17.5879 13.1897 17.4456C14.2732 17.2999 15.1283 16.9959 15.7994 16.3248C16.4705 15.6537 16.7745 14.7986 16.9202 13.7151C17.0625 12.6565 17.0625 11.2997 17.0625 9.56844V9.48234C17.0625 7.75106 17.0625 6.39428 16.9202 5.33567C16.7745 4.25212 16.4705 3.3971 15.7994 2.726C15.1283 2.05489 14.2732 1.75088 13.1897 1.6052C12.1311 1.46288 10.7744 1.46288 9.04305 1.46289H8.95695ZM2.9961 3.52149C3.42334 3.09425 4.00138 2.84908 4.96019 2.72017C5.93517 2.58908 7.21633 2.58789 9 2.58789C10.7837 2.58789 12.0648 2.58908 13.0398 2.72017C13.9986 2.84908 14.5766 3.09425 15.0039 3.52149C15.4312 3.94873 15.6764 4.52677 15.8052 5.48558C15.9363 6.46056 15.9375 7.74173 15.9375 9.52539C15.9375 11.309 15.9363 12.5902 15.8052 13.5652C15.6764 14.524 15.4312 15.102 15.0039 15.5293C14.5766 15.9566 13.9986 16.2017 13.0398 16.3306C12.0648 16.4617 10.7837 16.4629 9 16.4629C7.21633 16.4629 5.93517 16.4617 4.96019 16.3306C4.00138 16.2017 3.42334 15.9566 2.9961 15.5293C2.56886 15.102 2.32369 14.524 2.19478 13.5652C2.06369 12.5902 2.0625 11.309 2.0625 9.52539C2.0625 7.74173 2.06369 6.46056 2.19478 5.48558C2.32369 4.52677 2.56886 3.94873 2.9961 3.52149Z"
                                            fill="#1C274C" />
                                    </svg>
                                    <span class="ms-1" (click)="downloadPdf()">Download Policy</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>

<div *ngIf="isMultiplePaymentSuccess" class="payment-success-container">
    <h1>Payment Successful!</h1>
    <p>Thank you for your payment. Your transaction has been completed successfully.</p>
</div>